import { useEffect, useState } from 'react';
import '../../../scss/sub/_bookmark.scss';
import { motion } from 'framer-motion';
import Pagination from 'react-js-pagination';

export default function HubBookmarkCommodityModal(props) {
	const [ProductNos, setProductNos] = useState([]);
	const [Page, setPage] = useState(1); // 현재 페이지 번호
	const PostPerPage = 10; // 페이지 당 게시글 개수
	const indexOfLastPost = Page * PostPerPage;
	const indexOfFirstPost = indexOfLastPost - PostPerPage;

	const handlePageChange = (page, type) => {
		if (Page !== page) {
			return setPage(page);
		}
	};
	useEffect(() => {
		let array = props.bookmarkData.productNos.split(',');
		setProductNos(array);
	}, []);
	return (
		<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 0.1, duration: 0.2 } }} exit={{ opacity: 0, transition: { delay: 0.1, duration: 0.1 } }}>
			<div className='bookmark-slide-modal'>
				<div className='slide-overlay' onClick={(e) => props.getIsBookmarkModalOpen(false)}></div>
				<motion.div initial={{ x: 100 }} animate={{ x: 0, transition: { duration: 0.3 } }} exit={{ x: 100, transition: { duration: 0.2 } }}>
					<div className='slide-modal-content'>
						<div className='modal-header'>
							<h2>북마크 상품 목록</h2>
						</div>
						<button className='close-modal' onClick={() => props.getIsBookmarkModalOpen(false)}></button>
						<div className='modal-body'>
							<div className='commodity-table'>
								<div className='table-top'>
									<div className='table-top-left'>
										<p>{`상품목록 총 ${ProductNos?.length}개`}</p>
									</div>
								</div>
								<div className='data-table' style={{}}>
									<table>
										<thead>
											<tr>
												<th>No.</th>
												<th>productNo</th>
											</tr>
										</thead>
										<tbody>
											{ProductNos?.slice(indexOfFirstPost, indexOfLastPost).map((item, index) => (
												<tr key={index}>
													<td>{indexOfFirstPost + index + 1}</td>
													<td>{item}</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
								<Pagination
									activePage={Page}
									itemsCountPerPage={Number(PostPerPage)}
									totalItemsCount={ProductNos?.length || 0}
									pageRangeDisplayed={10}
									prevPageText={'‹'}
									nextPageText={'›'}
									onChange={(e) => handlePageChange(e, 'commodity')}
								/>
							</div>
						</div>
					</div>
				</motion.div>
			</div>
		</motion.div>
	);
}
